import { render } from "./Applyinput.vue?vue&type=template&id=4918bdea&scoped=true"
import script from "./Applyinput.vue?vue&type=script&lang=js"
export * from "./Applyinput.vue?vue&type=script&lang=js"

import "./Applyinput.vue?vue&type=style&index=0&id=4918bdea&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4918bdea"

export default script